import React from "react";
import ReactDOM from "react-dom/client";
import { analytics } from "@heycatch/sdk";
import "@/index.css";
import App from "@/App";

// HeyCatch analytics — static import, module scope, runs on every page.
// Autocapture handles pageviews, clicks and SPA route changes from here on.
// The Moonbucks frontend calls its FastAPI backend on a different host in
// preview (REACT_APP_BACKEND_URL) — same-origin in production — so we thread
// that host through tracingHosts so backend requests carry the session
// header for server-event attribution when it lands.
const _backendHost = (() => {
  try {
    return process.env.REACT_APP_BACKEND_URL ? new URL(process.env.REACT_APP_BACKEND_URL).host : "";
  } catch {
    return "";
  }
})();
analytics.init({
  projectKey: "hck_pk_SwzC6kdQ3kcaP0tiZtJEHilptQMW5AZB",
  install: {
    framework: "react",
    frameworkVersion: "19",
    agent: "other",
  },
  ...(_backendHost ? { tracingHosts: [_backendHost] } : {}),
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
